export const formatErrors = errorTypes => {
  return Object.entries(errorTypes).map(([type, message]) => {
    return { name: type, content: message };
  });
};

export const buildMatchingErrorArray = (newErrors, prevErrors) => {
  const matches = [];
  for (let i = 0; i < newErrors.length; i++) {
    for (let j = 0; j < prevErrors.length; j++) {
      if (newErrors[i].name === prevErrors[j].name) {
        matches.push(newErrors[i].name);
        break;
      }
    }
  }
  return matches;
};

export const validateFileSize = (bytes, limit, unit) => {
  if (bytes <= 0) {
    return false;
  }
  if (limit <= 0) {
    return false;
  }
  if (!unit) {
    return false;
  }

  const sizes = ['b', 'kb', 'mb', 'gb', 'tb'];
  const matchedUnitIndex = sizes.findIndex(value => value === unit);

  if (matchedUnitIndex === -1) {
    return false;
  }

  const sizeUnitIndex = parseInt(
    Math.floor(Math.log(bytes) / Math.log(1024)),
    10
  );

  if (sizeUnitIndex > matchedUnitIndex) {
    return false;
  }

  const result = Math.round(bytes / Math.pow(1024, sizeUnitIndex));

  if (sizeUnitIndex === matchedUnitIndex) {
    return result <= limit;
  }

  return sizeUnitIndex < matchedUnitIndex;
};
